import React, { useState, useEffect } from 'react';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import style from './style.scss';

export default function AuthForm(props) {

  const {loginUser, refetch_app_data} = props;

  const [pending, setPending] = useState(false)

  const username = useInputValue('')
  const password = useInputValue('')

  function loginClick() {

    loginUser({
      variables: {
        username: username.value,
        password: password.value,
      }
    }).then(() => {

      refetch_app_data();

    });
  }

  return (
    <div>

      <div className="auth_form">



        <div className="layout__row bottom_border">

          {/*USERNAME*/}
          <div className="layout__col_12">

            <div className="form__label">Логин</div>

            <div className="form__control">

              <input type="text" {...username}/>

            </div>

          </div>

          {/*PASSWORD*/}
          <div className="layout__col_12">

            <div className="form__label">Пароль</div>

            <div className="form__control">

              <input type="text" {...password}/>

            </div>

          </div>

        </div>



        <div className="layout__row bottom_border">

          <div className="layout__col_12">
            <div className="button button_green button_big lead_form__button" onClick={loginClick}>
              Сохранить
            </div>
          </div>

        </div>


      </div>



    </div>
  )

}

function useInputValue(initialValue) {
  const [value, setValue] = useState(initialValue)

  const onChange = (e) => setValue(e.target.value)

  return {value, onChange}
}





